import combineBenchlingReducers from 'util/combineBenchlingReducers';

import {
  LayoutConfigEventQueueState,
  reduceLayoutConfigEventQueue,
} from './data-layout/analysis-adapter/useHandleAnalysisLayoutEvents';

export interface AnalysisToolUIState {
  layoutConfigEventQueue: LayoutConfigEventQueueState;
}

export default combineBenchlingReducers({
  layoutConfigEventQueue: reduceLayoutConfigEventQueue,
});
